module.exports = __webpack_public_path__ + "static/img/6.a29afdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/6.png
// module id = q5OX
// module chunks = 0